module.exports = __webpack_public_path__ + "img/chinaUnionPay.3bbb1082.svg";